module.exports = __webpack_public_path__ + "static/img/tery.74c115b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/tery.svg
// module id = 6GEh
// module chunks = 1